import $ from 'jquery';

$(function () {
  const image = $('.js-changeImageOnHover');
  image.hover(
    function () {
      /*
       * pictureタグのときの処理
       */
      if (this.tagName.toLowerCase() === 'picture') {
        const originalSrc = $(this).children('img').attr('src');
        const sources = $(this).children('source');
        if (sources.length) {
          sources.each(function () {
            const originalSrcset = $(this).attr('srcset');
            const updatedSrcset = originalSrcset.replace(/(\.[^.]+)$/, '_on$1');
            $(this).attr('srcset', updatedSrcset);
          });
        }
        if (originalSrc) {
          const updatedSrc = originalSrc.replace(/(\.[^.]+)$/, '_on$1');
          $(this).children('img').attr('src', updatedSrc);
        }
      }

      /*
       * imgタグのときの処理
       */
      if (this.tagName.toLowerCase() === 'img') {
        const originalSrc = $(this).attr('src');
        if (originalSrc) {
          const updatedSrc = originalSrc.replace(/(\.[^.]+)$/, '_on$1');
          $(this).attr('src', updatedSrc);
        }
      }
    },
    function () {
      /*
       * pictureタグのときの処理
       */
      if (this.tagName.toLowerCase() === 'picture') {
        const updatedSrc = $(this).children('img').attr('src');
        const sources = $(this).children('source');
        if (sources.length) {
          sources.each(function () {
            const updatedSrcset = $(this).attr('srcset');
            const originalSrcset = updatedSrcset.replace(/_on(\.[^.]+)$/, '$1');
            $(this).attr('srcset', originalSrcset);
          });
        }
        if (updatedSrc) {
          const originalSrc = updatedSrc.replace(/_on(\.[^.]+)$/, '$1');
          $(this).children('img').attr('src', originalSrc);
        }
      }
      /*
       * imgタグのときの処理
       */
      if (this.tagName.toLowerCase() === 'img') {
        const updatedSrc = $(this).attr('src');
        if (updatedSrc) {
          const originalSrc = updatedSrc.replace(/_on(\.[^.]+)$/, '$1');
          $(this).attr('src', originalSrc);
        }
      }
    }
  );
});
